import keyMirror from 'keymirror'

// event names
riot.EVT = keyMirror({
  hilight: null,
  unhilight: null,
  hilightNode: null,
  unhilightNode: null,
  updatePositions: null,
  chartDrawed: null,
  tooltipChanged: null,
  clearSvg: null
})



/** WEBPACK FOOTER **
 ** ./src/stores/chart_store_events.js
 **/